<template>
  <div v-if="shouldShowButton" class="fab-wrapper">
    <!-- Bulle d'invitation -->
    <transition name="bubble-slide">
      <div v-if="showInvitationBubble" class="invitation-bubble" @click="goToChatPage">
        <button class="bubble-close" @click.stop="dismissBubble"><i class="fas fa-times"></i></button>
        <div class="bubble-header">
          <div class="bubble-avatar topup"><i class="fas fa-comments"></i></div>
          <span class="bubble-title">Top‑up Forum</span>
        </div>
        <div class="bubble-text">
          💬 <strong>Join the conversation!</strong> Chat with managers and other top‑ups.
        </div>
        <div class="bubble-footer">
          <span>Tap to open</span>
          <i class="fas fa-arrow-right"></i>
        </div>
      </div>
    </transition>

    <!-- Bouton flottant principal -->
    <button class="main-fab" @click="goToChatPage">
      <div class="fab-pulse"></div>
      <i class="fas fa-comment-dots"></i>
      <span v-if="totalUnread > 0" class="fab-badge">{{ totalUnread > 99 ? '99+' : totalUnread }}</span>
    </button>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'TopupFab',
  data() {
    return {
      showInvitationBubble: false,
      invitationTimeout: null,
      badgeUnread: 0,
      pollInterval: null,
    }
  },
  computed: {
    shouldShowButton() {
      const hideRoutes = ['dashboard.chat', 'chat_history', 'topup-chat']
      const currentRoute = this.$route && this.$route.name
      return !hideRoutes.includes(currentRoute)
    },
    totalUnread() {
      return this.badgeUnread
    },
  },
  mounted() {
    this.startInvitationSequence()
    this.fetchTotalUnread()
    this.startPolling()
  },
  beforeDestroy() {
    if (this.pollInterval) clearInterval(this.pollInterval)
    if (this.invitationTimeout) clearTimeout(this.invitationTimeout)
  },
  methods: {
    goToChatPage() {
      this.$router.push('/topup-chat')
    },
    async fetchTotalUnread() {
      try {
        const res = await axios.get('/api/v1/topup/total_unread/')
        this.badgeUnread = res.data.unread || 0
      } catch (e) { console.error(e) }
    },
    startPolling() {
      this.pollInterval = setInterval(() => {
        this.fetchTotalUnread()
      }, 8000)
    },
    startInvitationSequence() {
      if (localStorage.getItem('topup_chat_bubble_dismissed')) {
        this.showInvitationBubble = false
        return
      }
      setTimeout(() => {
        this.showInvitationBubble = true
        this.invitationTimeout = setTimeout(() => {
          this.showInvitationBubble = false
          localStorage.setItem('topup_chat_bubble_dismissed', 'true')
        }, 8000)
      }, 3000)
    },
    dismissBubble() {
      if (this.invitationTimeout) clearTimeout(this.invitationTimeout)
      this.showInvitationBubble = false
      localStorage.setItem('topup_chat_bubble_dismissed', 'true')
    },
  },
}
</script>

<style scoped>
.fab-wrapper {
  position: fixed;
  bottom: 80px;
  right: 30px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
}

.invitation-bubble {
  background: white;
  border-radius: 28px;
  padding: 14px 20px;
  max-width: 280px;
  box-shadow: 0 20px 35px -8px rgba(0,0,0,0.2), 0 0 0 1px rgba(0,0,0,0.02);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  border: none;
  position: relative;
  overflow: hidden;
}
.invitation-bubble::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #f59e0b, #d97706);
}
.bubble-close {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #f1f5f9;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.2s;
  color: #94a3b8;
  font-size: 12px;
}
.invitation-bubble:hover .bubble-close {
  opacity: 1;
}
.bubble-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}
.bubble-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bubble-avatar.topup {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  box-shadow: 0 4px 10px rgba(245,158,11,0.3);
}
.bubble-avatar i {
  color: white;
  font-size: 16px;
}
.bubble-title {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
}
.bubble-text {
  font-size: 12px;
  color: #475569;
  line-height: 1.4;
  margin-left: 46px;
  margin-bottom: 10px;
}
.bubble-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  font-size: 11px;
  font-weight: 500;
  color: #f59e0b;
  margin-top: 4px;
}
.main-fab {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f59e0b, #d97706);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(245,158,11,0.4), 0 0 0 4px rgba(245,158,11,0.2);
  color: white;
  font-size: 24px;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  position: relative;
  animation: fab-pulse 2s infinite;
}
.fab-pulse {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: rgba(245,158,11,0.4);
  animation: ring 1.5s infinite;
}
@keyframes ring {
  0% { transform: scale(1); opacity: 0.6; }
  100% { transform: scale(1.3); opacity: 0; }
}
@keyframes fab-pulse {
  0%, 100% { box-shadow: 0 6px 16px rgba(245,158,11,0.4), 0 0 0 4px rgba(245,158,11,0.2); }
  50% { box-shadow: 0 6px 20px rgba(245,158,11,0.6), 0 0 0 6px rgba(245,158,11,0.1); }
}
.fab-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  background: #ef4444;
  color: white;
  font-size: 11px;
  font-weight: 800;
  min-width: 22px;
  height: 22px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #0f172a;
  box-shadow: 0 2px 6px rgba(239,68,68,0.5);
}
</style>
